import { render, staticRenderFns } from "./DDropdown.vue?vue&type=template&id=4a8f914c&scoped=true&"
import script from "./DDropdown.vue?vue&type=script&lang=js&"
export * from "./DDropdown.vue?vue&type=script&lang=js&"
import style0 from "./DDropdown.vue?vue&type=style&index=0&id=4a8f914c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f914c",
  null
  
)

export default component.exports